export default __webpack_public_path__ + "static/media/maitre-germain-ilunga.2315719f.jpg";